export default __webpack_public_path__ + "static/media/story.c2b36226.svg";